import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatName'
})
export class FormatNamePipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return value; // Handle empty input
    return value.replace(/([A-Z])/g, ' $1').trim();
  }

}
